// extracted by mini-css-extract-plugin
export default {"activeMenuItem":"XMV3ePVPp0oGdrnT7bck","menuItem":"IBooKAiCNtfdQqoRsHSZ"};